<template>
  <div uk-height-viewport class="uk-flex uk-flex-middle">
    <div class="uk-width-3-3@m uk-width-1-3@s m-auto rounded">
      <div class="uk-child-width-2-2@m uk-grid-collapse" uk-grid>
        <div class="uk-card-default p-5 rounded">
          <div class="mb-4">
            <h3 class="mb-3"> {{ $t('forgot_password.header') }}</h3>
          </div>
          <form @submit.prevent="onSubmit()" novalidate>
            <div class="uk-form-group" style="margin-bottom: 30px">
              <label class="uk-form-label"> {{ $t('forgot_password.email_telephone') }} </label>
              <div class="uk-position-relative w-100">
                <span class="uk-form-icon">
                  <i class="icon-feather-mail"></i>
                </span>
                <input class="uk-input" v-model="form.username">
              </div>
            </div>


            <div class="uk-form-group">
              <password-validation :password="form.password" :passwordConfirmation="form.password_confirmation"
                                   class="uk-child-width-1@s"
                                   @update:password="form.password=$event"
                                   @update:passwordConfirmation="form.password_confirmation=$event"
                                   @update:isMatched="isPasswordsMatched=$event"
              />

            </div>

            <div class="uk-alert-danger" uk-alert v-if="errors">
              <a class="uk-alert-close" uk-close></a>
              <p style="color:red;">
                <i class="uil-exclamation-triangle mr-2"></i>{{ errors }}
              </p>
            </div>

            <div class="uk-alert-success" uk-alert v-if="message">
              <a class="uk-alert-close" uk-close></a>
              <p style="color:green;"><i class="uil-exclamation-triangle mr-2"></i>{{ message }}</p>
            </div>

            <div class="mt-4 uk-flex-middle uk-grid-small" uk-grid>
              <div class="uk-width-expand@s">
                <button type="button" class="btn mr-2" @click="$router.push({ name: 'login' })">
                  <i class="uil-arrow-left"></i> {{ $t('general.back') }}
                </button>
              </div>
              <div class="uk-width-auto@s">
                <button type="submit" class="btn btn-default" :disabled="!isPasswordsMatched">
                  {{ $t('forgot_password.send') }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";
import { RESET_PASSWORD, SET_ERROR } from "@/core/services/store/auth.module";
import { DomainMapper } from "@/core/config/domain-mapper";
import PasswordValidation from "@/view/components/validation/PasswordValidation.vue";

export default {
  name: "ForgotPassword",
  components: {PasswordValidation},
  data() {
    return {
      form: {
        username: null,
        password: null,
        password_confirmation: null,
        token: null,
        alias: null,
      },
      message: null,
      passwordType: false,
      confirmPasswordType: false,
      isPasswordsMatched: false,
    }
  },
  computed: {
    ...mapState({
      errors: state => state.auth.errors
    }),
  },
  methods: {
    showPassword(element) {
      switch (element) {
        case "passwordType":
          this.passwordType = !this[element];
          break;
        case "confirmPasswordType":
          this.confirmPasswordType = !this[element];
          break;
      }
    },
    onSubmit() {
      let form = this.form

      form.alias =  process.env.VUE_APP_DEFAULT_SUBDOMAIN

      if (['production', 'staging','develop'].includes(process.env.NODE_ENV)) {
        form.alias = window.location.hostname.split(".")[0];
        if (["production"].includes(process.env.NODE_ENV) && DomainMapper.hasOwnProperty(window.location.hostname)){
          form.alias = DomainMapper[window.location.hostname] || form.alias;
        }
      }

      if (this.form.password == null || this.form.password.length < 7) {
        this.$store.commit(SET_ERROR,
            this.$t('errors.password_must_more_than_7')
        );
        return false
      }
      if (this.form.password !== this.form.password_confirmation) {
        let errorMessage = this.$t('errors.password_dont_match')
        this.$store.commit(SET_ERROR, errorMessage)
        return false
      }
      // send forgot password request
      this.$store.dispatch(RESET_PASSWORD, form)
          .then((response) => {
            this.message = this.$t('messages.reset_password_successfully')
            setTimeout(() => this.$router.push({ name: 'login' }), 1000);
          })
    }
  },
  mounted() {
    // Reset password için köprüleme:
    if (!window.location.hash) {
      const targetHash = '#/reset-password/' + this.form.token
      window.location.hash = targetHash
    }

    this.$store.commit(SET_ERROR, '')
    this.form.token = this.$route.params.token
    if (!this.form.token) {
      this.$router.push({ name: "login" })
    }

    if (process.env.NODE_ENV === 'production') {
      this.form.alias = window.location.hostname.split(".")[0];
      if (["production"].includes(process.env.NODE_ENV) && DomainMapper.hasOwnProperty(window.location.hostname)){
        this.form.alias = DomainMapper[window.location.hostname] || this.form.alias;
      }
    }
  }
}
</script>

<style scoped>
.password-validation {
  display: flex;
  flex-direction: column;
  padding:initial !important;
}

.uk-form-group :deep(.uk-child-width-1-2\@s) > * {
  width: 100% !important;
}

.uk-first-column {
  width: 100% !important;
}
</style>

